import { render, staticRenderFns } from "./defaultText.vue?vue&type=template&id=07cc865e&scoped=true"
import script from "./defaultText.vue?vue&type=script&lang=js"
export * from "./defaultText.vue?vue&type=script&lang=js"
import style0 from "./defaultText.vue?vue&type=style&index=0&id=07cc865e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc865e",
  null
  
)

export default component.exports